import React, { useState } from "react";
import CraftDesignList from "./CraftDesignList";
import CataCraftDesigner from "./cata_craft_bulk_upload_pdf_preview";

const CraftDesignManager = () => {
  const [viewMode, setViewMode] = useState("list"); // "list" | "detail"
  const [currentDesign, setCurrentDesign] = useState(null);

  const handleViewDetails = (design) => {
    setCurrentDesign(design);
    setViewMode("detail");
  };

  const handleCreateNew = () => {
    setCurrentDesign(null);
    setViewMode("detail");
  };

  const handleBackToList = () => {
    setCurrentDesign(null);
    setViewMode("list");
  };

  if (viewMode === "detail") {
    return (
      <CataCraftDesigner
        activeDesign={currentDesign}
        onBackToList={handleBackToList}
      />
    );
  }

  return (
    <CraftDesignList
      onViewDetails={handleViewDetails}
      onCreateNew={handleCreateNew}
    />
  );
};

export default CraftDesignManager;
